import { toFlatField } from '../oasis-types';
export const LabDrawVersioned = {
    labdraw: { e1: { alias: 'labdraw', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
};
export const Labdraw = toFlatField(LabDrawVersioned);
